/**
 * Auto-calculate proposal estimated monthly revenue from units × rent × fee%.
 * Listens for input events on the three source fields via event delegation.
 */
(function () {
    var SOURCE_IDS = ['id_num_units', 'id_avg_monthly_rent', 'id_management_fee_pct'];

    function calcProposalRevenue() {
        var units = parseInt(document.getElementById('id_num_units')?.value) || 0;
        var rent = parseFloat(document.getElementById('id_avg_monthly_rent')?.value) || 0;
        var feePct = parseFloat(document.getElementById('id_management_fee_pct')?.value) || 0;
        var revenueInput = document.getElementById('id_estimated_monthly_revenue');
        if (!revenueInput) return;

        if (units > 0 && rent > 0 && feePct > 0) {
            var totalFeePct = feePct + 3;  // +3% for ancillary fees
            var monthly = units * rent * totalFeePct / 100;
            revenueInput.value = monthly.toFixed(2);
        }
    }

    document.addEventListener('input', function (e) {
        if (e.target && e.target.id && SOURCE_IDS.indexOf(e.target.id) !== -1) {
            calcProposalRevenue();
        }
    });

    // "CC me" — append the current user's email to the proposal CC field,
    // then fire change so the inline autosave (hx-trigger="change") persists it.
    document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-cc-me-target]');
        if (!btn) return;
        var input = document.getElementById(btn.getAttribute('data-cc-me-target'));
        var email = btn.dataset.email;
        if (!input || !email) return;
        var parts = input.value.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
        if (parts.indexOf(email) === -1) parts.push(email);
        input.value = parts.join(', ');
        input.dispatchEvent(new Event('change', { bubbles: true }));
    });
})();
